/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ds from 'designsystem';
import chunk from 'lodash/chunk';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { scrollToElement, FADE_VALUES } from 'animations/Animations';
import { Column, Row } from 'hedron';
import Fade from 'react-reveal/Fade';
import { SimpleAccordion as SimpleAccordionModel } from 'models';
import Container from 'blocks/Container/Container';
import { media } from 'designsystem/index';
import { Bind } from 'lodash-decorators';
import ScrollDiv from 'blocks/ScrollDiv';
import SCROLL from 'common/consts/scroll';

import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import PanelGroup from './PanelGroup/index';
import Title from './Title';
import QuestionsWrapper from './QuestionsWrapper';

const SimpleAccordion = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${ds.get('metrics.m')} auto;
  padding-bottom: ${ds.get('metrics.s')};
  width: 100%;
  ${media.desktop`
    flex-direction: row;
    min-height: 300px;
    margin: ${ds.get('metrics.xl')} auto;
    `};
`;

const SimpleText = styled.span``;

@inject('windowStore')
@observer
export default class SimpleAccordionBlock extends Component {
  activeKey = observable.box(0);

  static propTypes = {
    data: PropTypes.instanceOf(SimpleAccordionModel).isRequired,
  };

  constructor(props) {
    super(props);
    const {
      data: {
        simpleAccordionItems,
      },
    } = this.props;
    this.scrollRefs = simpleAccordionItems.map(() => React.createRef());
  }

  @Bind
  scrollTo(scrollRef) {
    const { windowStore } = this.props;
    if (windowStore.isOnTablet) {
      scrollToElement(scrollRef.current, 200);
    }
  }

  render() {
    const { data } = this.props;
    const questions = data.simpleAccordionItems;
    const [LeftColData, RightColData] = chunk(questions, Math.ceil(questions.length / 2));
    const scrollOffset = `-${SCROLL.SIMPLE_ACCORDION_TOP_OFFSET}px`;
    return (
      <HTMLModifiableBackground
        htmlModifiers={data.htmlModifiers}
        color={ds.brand('white')}
      >
        <Container>
          <SimpleAccordion>
            <Column
              lg={4}
            >
              <Fade
                bottom
                distance={`${FADE_VALUES.BOX.SMALL}`}
                delay={FADE_VALUES.DELAY.SMALL}
              >
                <Title
                  dangerouslySetInnerHTML={{
                    __html: safeHtmlWithBr(data.header),
                  }}
                />
              </Fade>
            </Column>
            <Column lg={8}>
              <QuestionsWrapper>
                <Fade
                  bottom
                  cascade
                  distance={`${FADE_VALUES.BOX.SMALL}`}
                  delay={FADE_VALUES.DELAY.SMALL}
                >
                  <Row
                    alignItems="flex-start"
                  >
                    <Column
                      fluid
                      lg={6}
                    >
                      <PanelGroup
                        accordion
                        defaultActiveKey={0}
                        activeKey={this.activeKey.get()}
                        onSelect={activeKey => this.activeKey.set(activeKey)}
                        id="FAQ.LeftPanel"
                      >
                        {LeftColData.map((question, index) => (
                          <PanelGroup.Panel
                            eventKey={index}
                            key={question.system.id}
                          >
                            <PanelGroup.Heading>
                              <ScrollDiv
                                offset={scrollOffset}
                                innerRef={this.scrollRefs[index]}
                              />
                              <PanelGroup.Title
                                toggle
                                onClick={() => this.scrollTo(this.scrollRefs[index])}
                              >
                                <SimpleText
                                  dangerouslySetInnerHTML={{
                                    __html: safeHtmlWithBr(question.title),
                                  }}
                                />
                              </PanelGroup.Title>
                            </PanelGroup.Heading>
                            <PanelGroup.Body
                              collapsible
                              dangerouslySetInnerHTML={{
                                __html: question.text,
                              }}
                            />
                          </PanelGroup.Panel>
                        ))}
                      </PanelGroup>
                    </Column>
                    <Column fluid lg={6}>
                      <PanelGroup
                        accordion
                        activeKey={this.activeKey.get()}
                        onSelect={activeKey => this.activeKey.set(activeKey)}
                        id="FAQ.RightPanel"
                      >
                        {RightColData.map((question, index) => {
                          const rightColIndex = index + LeftColData.length + 1;
                          return (
                            <PanelGroup.Panel
                              eventKey={rightColIndex}
                              key={rightColIndex}
                            >
                              <PanelGroup.Heading>
                                <ScrollDiv
                                  offset={scrollOffset}
                                  innerRef={this.scrollRefs[LeftColData.length + index]}
                                />
                                <PanelGroup.Title
                                  toggle
                                  onClick={
                                    () => this.scrollTo(this.scrollRefs[LeftColData.length + index])
                                  }
                                >
                                  <SimpleText
                                    dangerouslySetInnerHTML={{
                                      __html: (question.title),
                                    }}
                                  />
                                </PanelGroup.Title>
                              </PanelGroup.Heading>
                              <PanelGroup.Body
                                collapsible
                                dangerouslySetInnerHTML={{
                                  __html: question.text,
                                }}
                              />
                            </PanelGroup.Panel>
                          );
                        })}
                      </PanelGroup>
                    </Column>
                  </Row>
                </Fade>
              </QuestionsWrapper>
            </Column>
          </SimpleAccordion>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/SimpleAccordion/index.jsx